import { DocFile } from 'src/app/models/docfile.model'

export const DOCFILE2: DocFile = new DocFile({
    idDocFile: '779d0842375073e8bc58b0bad5106027',
    order: 2,
    name: 'Instituto',
    url: 'http://cedoc.inmujeres.gob.mx/documentos_download/INMUJERES_EN_2021_F.pdf'
});